import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-toggle-buttons',
    templateUrl: './toggle-buttons.component.html',
    styleUrls: ['./toggle-buttons.component.scss'],
    standalone: false
})
export class ToggleButtonsComponent implements OnInit, OnChanges {
  @Input() parentFormGroup: FormGroup = new FormGroup<any>({});
  @Input() controlName = '';
  @Input() buttonLabels: any = ['Pass', 'Fail', 'N/A'];
  @Input() labelCase = '';
  @Input() heading = '';

  // Plain-value alternative to the FormGroup binding. Use these when the
  // toggle isn't part of a reactive form (e.g. transient toolbar state).
  // Either bind `parentFormGroup`+`controlName` OR `value`+`valueChange`.
  @Input() value: any = undefined;
  @Output() valueChange = new EventEmitter<any>();

  // Optional per-button hover tooltip text, parallel to `buttonLabels` by
  // index. Useful when labels are abbreviated for space (e.g. "SBS") and the
  // full meaning needs to surface on hover.
  @Input() buttonTooltips: string[] = [];

  // Optional per-button test hook: renders data-testid="<prefix><label>".
  @Input() testIdPrefix = '';

  // Opt-in compact number picker (risk register Probability / Impact): a pill sized to
  // its options with spacing between them and a circular selected state (Figma selected
  // pill 23210:68579). Default layout is unchanged.
  @Input() compact = false;

  selectedLabel: number | null = null;

  private get usesFormGroup(): boolean {
    return !!this.controlName;
  }

  ngOnInit(): void {
    if (this.buttonLabels?.length === 0) {
      this.buttonLabels = ['Pass', 'Fail', 'N/A'];
    }
    this.syncSelectionFromInputs();
  }

  ngOnChanges() {
    this.syncSelectionFromInputs();
  }

  onLabelClick(index: number) {
    this.selectedLabel = index;
    const next = this.buttonLabels[index];
    if (this.usesFormGroup) {
      this.parentFormGroup.controls[this.controlName]?.setValue(next);
    }
    this.valueChange.emit(next);
  }

  isSelected(index: number): boolean {
    return this.selectedLabel === index;
  }

  private syncSelectionFromInputs(): void {
    const currentValue = this.usesFormGroup
      ? this.parentFormGroup.controls[this.controlName]?.value
      : this.value;
    if (currentValue !== undefined) {
      this.selectedLabel = this.buttonLabels?.indexOf(currentValue);
    }
  }
}
